import React from 'react';
import { withRouter } from 'react-router-dom'
import "./Profile.css";
import Navbar from "../Components/Navbar";
import Footer from "../Components/Footer";
import Swal from 'sweetalert2'
import axios from 'axios';
import cloneDeep from 'lodash/cloneDeep';
import DatePicker from "react-datepicker";
//import {parse, stringify} from 'flatted';
import 'rc-time-picker/assets/index.css';
import TimePicker from 'rc-time-picker';
import store from "../store/index";
import i18n from '../i18n';
import "react-datepicker/dist/react-datepicker.css";

import moment from 'moment';
import { API_MOSA_URL, ACCESS_TOKEN_NAME } from '../constants/apiContants';
import LoadingOverlay from 'react-loading-overlay';
import "./Dash.css";

const format = 'h:mm a';

const now = moment().hour(0).minute(0);

const devicedetails = {
  "imei": "862188038288320",
  "deviceOSVersion": "6.0.1",
  "uuid": "862188038288320",
  "deviceModel": "NOKIA 100",
  "deviceManufacturer": "Xiaomi",
  "serviceProvider": "airtel",
  "deviceOS": "ANDROID",
  "ipAddress": "192.168.43.210"
}
const headers = {
  "RequestMode": "0",
  "UserID": localStorage.getItem('userid'),
  "BearerKey": "Mobile",
  "ServiceId": "SERV!",
  "SessionId": localStorage.getItem(ACCESS_TOKEN_NAME),
  "Locale": "E/A",
  "DeviceDet": devicedetails

}

class EventDetails extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      startDate: new Date(),
      endDate: new Date(),
      eventname: '',
      page: 1,
      pkid: '',
      eventcreated: false,
      event_desc: '',
      approve_status: 'Pending',
      locations: [],
      stadiums: [],
      facilities: [],
      location: '',
      stadium: '',
      lang:'en',
      start_date: '',
      end_date: '',
      stadium_name_en: '',
      cost: '0.000',
      isActive: false
    };

  }

  calculateCost = () => {

    var newcost = "0.000";

    this.state.facilities.forEach((facility, index) => {
      if (facility.check_status === "true") {

        newcost = parseFloat(newcost) + parseFloat(facility.rate);

        facility.lstAttributes.forEach((attribute, subindex) => {
          if (attribute.check_status === "true") {

            newcost = parseFloat(newcost) + parseFloat(attribute.rate);

          }
        });
      }
    });


    this.setState({ cost: newcost });


  }
  handleFacilityAttribute = (e, x, updatedfacility) => {

    this.calculateCost();

    var attributecost = e.target.value.split("_")[2];
    var facilityid = e.target.value.split("_")[1];
    var attrid = e.target.value.split("_")[0];
    var attractive = e.target.value.split("_")[3];

    var currentcost = parseFloat(this.state.cost);

    x.check_status = attractive === "true" ? "false" : "true";

    this.calculateCost();


  }

  handleFacility = (e, updatedfacility) => {


    var newcost = parseFloat(this.state.cost);

    var facilityid = e.target.value.split("_")[2];
    var facilityactive = e.target.value.split("_")[1];
    updatedfacility.check_status = facilityactive === "true" ? "false" : "true";


    this.calculateCost();
  }

  handleFacilityDate = (date, updatedfacility) => {
    console.log('dsd1' + date);
    updatedfacility.start_date = date;
    this.calculateCost();
  }

  handleFacilityDateEnd = (date, updatedfacility) => {
    console.log('dsd' + date);
    updatedfacility.end_date = date;
    this.calculateCost();
  }

  handleFacilityTime = (time, updatedfacility) => {
    console.log('dsd1' + time);
    updatedfacility.start_time = time;
    this.calculateCost();
  }

  handleFacilityTimeEnd = (time, updatedfacility) => {
    console.log('dsd' + time);
    updatedfacility.end_time = time;
    this.calculateCost();
  }

  addfacilityEvent = () => {


    // headers.UserID = this.props.location.state.userid;
    // headers.SessionId = this.props.location.state.sessionid;

    // redirectToHome();
    const nfacilities = cloneDeep(this.state.facilities);
    // var nfacilities = this.state.facilities;
    const mosaa = { event_id: this.state.event_id, "facility_list": nfacilities, ReqHead: headers }
    // console.log('calling api ...' + JSON.stringify(payload));
    let self = this; //  declared var welcom

    this.setState({ isActive: true });

    console.log('calling api ...' + JSON.stringify(mosaa));
    // stringify(mosa);

    axios.post(API_MOSA_URL + '/Company/EventFacilityInsert', mosaa)
      .then(function (response) {
        console.log(JSON.stringify(response));
        // self.redirectToValidate();
        self.setState({ isActive: false });

        if (response.status === 200) {
          if (response.data[0].StatusCode == "0") {
            Swal.fire({
              title: 'Success',
              text: 'Your Event data is updated',
              icon: 'success',
              confirmButtonText: 'Ok'
            }).then((result) => {
              if (result.value) {
                window.location.reload(false);
                // self.props.history.push('/profile');
              }
            })
          } else {
            Swal.fire({
              title: 'Error!!!!!',
              text: response.data[0].Message,
              icon: 'error',
              confirmButtonText: 'Ok'
            })
          }


        } else {
          Swal.fire({
            title: 'Error!**',
            text: 'Please try again later!',
            icon: 'error',
            confirmButtonText: 'Ok'
          })
        }

      })
      .catch(function (error) {
        // console.log(error);
        self.setState({ isActive: false });
        Swal.fire({
          title: 'Error!--->',
          text: 'Please try again later!',
          icon: 'error',
          confirmButtonText: 'Ok'
        })

      });




  }

  confirmdelete = () => {
    let self = this;
    Swal.fire({
      title: "Are you sure?",
      text: "Once deleted, you will not be able to recover this form!",
      icon: "warning",
      buttons: true,
      dangerMode: true,
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes!'
    }).then((result) => {
      if (result.value) {
        self.deleteEvent();
      } else {

      }
    });
  }

  deleteEvent = () => {


    // headers.UserID = this.props.location.state.userid;
    // headers.SessionId = this.props.location.state.sessionid;
    // redirectToHome();
    const nfacilities = cloneDeep(this.state.facilities);
    // var nfacilities = this.state.facilities;
    const mosaa = { event_id: this.state.event_id, ReqHead: headers }
    // console.log('calling api ...' + JSON.stringify(payload));
    let self = this; //  declared var welcom

    this.setState({ isActive: true });

    console.log('calling DELETE api ...' + JSON.stringify(mosaa));
    // stringify(mosa);

    axios.post(API_MOSA_URL + '/Company/EventDelete', mosaa)
      .then(function (response) {
        console.log(JSON.stringify(response));
        // self.redirectToValidate();
        self.setState({ isActive: false });

        if (response.status === 200) {
          if (response.data[0].StatusCode == "0") {
            Swal.fire({
              title: 'Success',
              text: 'Your Event  is deleted',
              icon: 'success',
              confirmButtonText: 'Ok'
            }).then((result) => {
              if (result.value) {
                // window.location.reload(false);
                self.props.history.push('/profile');
              }
            })
          } else {
            Swal.fire({
              title: 'Error!!!!!',
              text: response.data[0].Message,
              icon: 'error',
              confirmButtonText: 'Ok'
            })
          }


        } else {
          Swal.fire({
            title: 'Error!**',
            text: 'Please try again later!',
            icon: 'error',
            confirmButtonText: 'Ok'
          })
        }

      })
      .catch(function (error) {
        // console.log(error);
        self.setState({ isActive: false });
        Swal.fire({
          title: 'Error!--->',
          text: 'Please try again later!',
          icon: 'error',
          confirmButtonText: 'Ok'
        })

      });




  }

  componentDidMount() {

    // headers.UserID = this.props.location.state.userid;
    // headers.SessionId = this.props.location.state.sessionid;

    let self = this; //  declared var welcom

    this.setState({ isActive: true });
    const mosa = {
      ReqHead: headers, "event_id": this.props.location.state.eventid,
      "stadium_id": this.props.location.state.stadiumid,
    }
    console.log('calling events list ....' + JSON.stringify(mosa));


    axios.post(API_MOSA_URL + '/Company/GetMyEventDetails', mosa)

      .then(function (response) {
        console.log(JSON.stringify(response.data));
        // self.redirectToValidate();
        self.setState({ isActive: false });

        if (response.status === 200) {

          if (response.data[0].StatusCode == "0") {

            self.setState({ eventname: response.data[1].event_name });
            self.setState({ event_desc: response.data[1].event_description });
            self.setState({ stadium_name_en: response.data[1].stadium_name_en });
            self.setState({ approve_status: response.data[1].approve_status });
            self.setState({ event_id: response.data[1].event_id });
            self.setState({ start_date: response.data[1].date_from });
            self.setState({ end_date: response.data[1].date_to });

            self.setState({ facilities: response.data[2] });
            self.calculateCost();
            window.scrollTo(0, 0);


          } else {
            Swal.fire({
              title: 'Error!',
              text: response.data[0].Message,
              icon: 'error',
              confirmButtonText: 'Ok'
            })
          }

        } else {
          Swal.fire({
            title: 'Error!',
            text: 'Please try again later!',
            icon: 'error',
            confirmButtonText: 'Ok'
          })
        }

      })
      .catch(function (error) {
        console.log(error);
        self.setState({ isActive: false });
        Swal.fire({
          title: 'Error!',
          text: 'Please try again later!',
          icon: 'error',
          confirmButtonText: 'Ok'
        })

      });

  }


  render() {
    let self = this;
        store.subscribe(() => {
            console.log('change lang' + store.getState().lang);
            localStorage.setItem('lang', store.getState().lang)

            self.setState({ lang: localStorage.getItem('lang') });
        });


    let eventsummaryNodes = this.state.facilities.map(function (facility, index) {
      var formattedStartDate = moment(facility.start_date).format('MM/DD/YYYY');

      var formattedEndDate = moment(facility.end_date).format('MM/DD/YYYY');
      return <tr key={index} >
          <td >{index+1}</td>
          <td><strong><span style={{color:'grey'}}>{facility.facility_name_en}</span></strong>
          <br />from: {formattedStartDate} to : {formattedEndDate}</td>
          <td> {facility.total_hour}</td>
          <td>OMR {facility.rate}</td>
          <td>OMR {facility.total_rate}</td>
      </tr>
  });

    // let commentNodes = this.state.facilities.map(function (facility, index) {
    //   return <div key={index} className="border-bottom">
    //     <br />
    //     <div className="border">
    //       <div className="card card-custom">
    //         <div className="card-header card-header-right ribbon ribbon-clip ribbon-left">
    //           <div className="row">
    //             <div className="col-md-10">
    //               <div className="text-left" style={{ top: '12px' }}>
    //                 <span className="text-muted" />OMR {facility.rate}</div>
    //               <h3 className="card-title text-left">{facility.facility_name_en}</h3>

    //             </div>
    //             <div className="col-md-2">
    //               <label className="checkbox checkbox-square">
    //                 <input type="checkbox"
    //                   checked={facility.check_status === "true" ? true : false}
    //                   value={facility.rate + "_" + facility.check_status + "_" + facility.facility_mast_id}
    //                   onChange={(e) => {
    //                     self.handleFacility(e, facility);
    //                   }}
    //                   name="Checkboxes1" />
    //                 <span />
    //               </label>
    //             </div>
    //           </div>
    //         </div>



    //         {facility.check_status === "true" &&
    //           <div className="card-body">
    //             <div className=" row text-left" style={{ paddingRight: '5px', paddingLeft: '5px' }}>
    //               <label className="col-md-2 col-form-label form-control-label text-muted" style={{ fontSize: '10px' }}> Start Date</label>
    //               <div className="col-md-4">
    //                 <DatePicker
    //                   className="form-control"
    //                   dateFormat="dd/MM/yyyy"
    //                   value={facility.start_date}
    //                   minDate={moment().toDate()}
    //                   selected={facility.start_date}
    //                   onChange={date => { self.handleFacilityDate(date, facility) }}

    //                 />
    //               </div>
    //               <label className="col-md-2 col-form-label form-control-label text-left text-muted" style={{ fontSize: '10px' }}>End Date</label>
    //               <div className="col-md-4">
    //                 <DatePicker
    //                   className="form-control"
    //                   dateFormat="dd/MM/yyyy"
    //                   value={facility.end_date}
    //                   minDate={moment().toDate()}
    //                   selected={facility.end_date}
    //                   onChange={date => { self.handleFacilityDateEnd(date, facility) }}

    //                 />
    //               </div>
    //             </div>
    //             <br />
    //             <div className=" row text-left" style={{ paddingRight: '5px', paddingLeft: '5px' }}>
    //               <label className="col-md-2 col-form-label form-control-label text-muted" style={{ fontSize: '10px' }}> Start Time</label>
    //               <div className="col-md-4">

    //                 <TimePicker
    //                   showSecond={false}
    //                   defaultValue={now}
    //                   onChange={date => { self.handleFacilityTime(date, facility) }}
    //                   format={format}
    //                   value={facility.start_time}
    //                   use12Hours
    //                   inputReadOnly
    //                 />
    //               </div>
    //               <label className="col-md-2 col-form-label form-control-label text-left text-muted" style={{ fontSize: '10px' }}>End Time</label>
    //               <div className="col-md-4">
    //                 <TimePicker
    //                   showSecond={false}
    //                   defaultValue={now}
    //                   onChange={date => { self.handleFacilityTimeEnd(date, facility) }}
    //                   format={format}
    //                   value={facility.end_time}
    //                   use12Hours
    //                   inputReadOnly
    //                 />
    //               </div>
    //             </div>
    //             <br />
    //             <div className="row" style={{ paddingRight: '15px', paddingLeft: '15px' }}>

    //               {facility.lstAttributes.map(x =>
    //                 <div className="d-flex align-items-center border">

    //                   <label className="checkbox checkbox-lg checkbox-light-success checkbox-inline flex-shrink-0 m-0 mx-4">
    //                     <input
    //                       type="checkbox"
    //                       value={x.facility_attribute_mast_id + "_" + x.facility_id + "_" + x.rate + "_" + x.check_status}
    //                       checked={x.check_status === "true" ? true : false}
    //                       onChange={(e) => {
    //                         self.handleFacilityAttribute(e, x, facility);
    //                       }} />
    //                     <span />
    //                   </label>

    //                   <div className="d-flex flex-column flex-grow-1" style={{ padding: '5px' }}>
    //                     <a href="#" className="text-dark-75 text-hover-primary font-weight-bold font-size-lg mb-1">{x.attribute_name_en}</a>
    //                     <span className="text-muted font-weight-bold">Extra charges OMR : {x.rate}</span>
    //                   </div>

    //                   <span style={{ margin: '5px' }} className="bullet bullet-bar bg-success align-self-stretch" />


    //                 </div>
    //               )}
    //             </div>
    //           </div>
    //         }



    //       </div>

    //     </div>
    //   </div>;
    // });
    return (
      <LoadingOverlay
        active={this.state.isActive}
        spinner
        text='Loading ...'
      >
        <Navbar />
        <div className="all-title-box">
          <div className="container text-center">
            <h1>{i18n.t('JK227', this.state.lang)}<span className="m_1">Find out the status of your event and edit.</span></h1>
          </div>
        </div>
        <div style={{ backgroundColor: 'lightgrey' }}>
          <div className="container">
            <br />
            <div className="card bootstrap snippets bootdeys">
              <div className="row">
                <div className="col-sm-12">
                  <div className="panel panel-default invoice" id="invoice">
                    <div className="panel-body">
                      <div className="invoice-ribbon"><div className="ribbon-inner">{this.state.approve_status}</div></div>
                      <div className="row">
                        <div className="col-md-10 top-left">
                          {this.state.approve_status === "Pending" &&
                            <div className="alert-message alert-message-warning">
                              <h4>
                              {i18n.t('JK38', this.state.lang)}</h4>
                              <p>
                              {i18n.t('JK39', this.state.lang)}
                               </p>
                            </div>
                          }

                          {this.state.approve_status === "Approved" &&
                            <div className="alert-message alert-message-warning">
                              <h4>
                              {i18n.t('JK228', this.state.lang)}</h4>
                              <p>
                              {i18n.t('JK229', this.state.lang)}                </p>
                            </div>
                          }
                        </div>
                      </div>
                      <hr />

                     <div className="form-group row">
                          <label className="col-lg-3 col-form-label form-control-label">{i18n.t('JK40', this.state.lang)} </label>
                          <div className="col-lg-9">
                            <input className="form-control" disabled={true} value={this.state.eventname} name={i18n.t('JK40', this.state.lang)}  onChange={this.myChangeHandler} type="text" placeholder=" Event Name" />
                          </div>
                        </div>
                        <div className="form-group row">
                          <label className="col-lg-3 col-form-label form-control-label">{i18n.t('JK41', this.state.lang)} </label>
                          <div className="col-lg-9">
                            <textarea disabled={true} className="form-control" value={this.state.event_desc} name="eventdesc" onChange={this.myChangeHandler} rows="4"
                              placeholder={i18n.t('JK41', this.state.lang)} />
                          </div>
                        </div>
                        <div className="form-group row">
                          <label className="col-lg-3 col-form-label form-control-label">{i18n.t('JK42', this.state.lang)}</label>
                          <div className="col-lg-9">
                            <input className="form-control" disabled={true} value={this.state.stadium_name_en} name="stadiumname" onChange={this.myChangeHandler} type="text" placeholder={i18n.t('JK41', this.state.lang)} />
                          </div>
                        </div>
                        <div className="form-group row">
                          <label className="col-lg-3 col-form-label form-control-label">{i18n.t('JK43', this.state.lang)}</label>
                          <div className="col-lg-9">
                            <input className="form-control" disabled={true} value={this.state.start_date} name="stadiumname" onChange={this.myChangeHandler} type="text" placeholder={i18n.t('JK43', this.state.lang)} />
                          </div>
                        </div>
                        <div className="form-group row">
                          <label className="col-lg-3 col-form-label form-control-label">{i18n.t('JK44', this.state.lang)}</label>
                          <div className="col-lg-9">
                            <input className="form-control" disabled={true} value={this.state.end_date} name="stadiumname" onChange={this.myChangeHandler} type="text" placeholder=" End Date" />
                          </div>
                        </div>

                      <div className="row table-row">
                        <table className="table table-striped">
                          <thead>
                            <tr>
                              <th>#</th>
                              <th>{i18n.t('JK45', this.state.lang)}</th>
                              <th>{i18n.t('JK46', this.state.lang)}</th>
                              <th>{i18n.t('JK47', this.state.lang)}</th>
                              <th>{i18n.t('JK48', this.state.lang)}</th>
                            </tr>
                          </thead>
                          <tbody>
                            {eventsummaryNodes}
                          </tbody>
                        </table>
                      </div>
                      <div className="row">
                        <div className="col-md-10 margintop">
                          <button className="btn btn-success" style={{margin:'5px'}} disabled={this.state.approve_status !== "Approved"} id="invoice-print"> {i18n.t('JK49', this.state.lang)}</button>
                          <button className="btn btn-danger" onClick={this.confirmdelete} style={{margin:'5px'}}> {i18n.t('JK50', this.state.lang)}</button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* <div className=" container">

            <br />
            <div className="card">
              <div className="card-header">
                <h4 className="mb-0"><span className="text-muted"></span> Event Details</h4>
              </div>
              <div className="card-body">
                {this.state.approve_status === "Pending" &&
                  <div className="alert-message alert-message-warning">
                    <h4>
                      Pending Approval</h4>
                    <p>
                      Your request is pending approval from MOSA admin. You can edit the list of facilities till the request is approved.</p>
                  </div>
                }

                {this.state.approve_status === "Approved" &&
                  <div className="alert-message alert-message-warning">
                    <h4>
                      Your Request is Approved</h4>
                    <p>
                      Please make payment to complete the request                  </p>
                  </div>
                }

                <div className="form-group row">
                  <div className="col-md-6" >
                    <div className="form-group row">
                      <div className="col-md-1" />
                      <div className="col-md-10" style={{ minHeight: '250px' }}>
                        <br />
                        <div className="form-group row">
                          <label className="col-lg-3 col-form-label form-control-label">Event Name</label>
                          <div className="col-lg-9">
                            <input className="form-control" disabled={true} value={this.state.eventname} name="eventname" onChange={this.myChangeHandler} type="text" placeholder=" Event Name" />
                          </div>
                        </div>
                        <div className="form-group row">
                          <label className="col-lg-3 col-form-label form-control-label">Event Description</label>
                          <div className="col-lg-9">
                            <textarea disabled={true} className="form-control" value={this.state.event_desc} name="eventdesc" onChange={this.myChangeHandler} rows="4"
                              placeholder="Event Description (max 200 characters)" />
                          </div>
                        </div>
                        <div className="form-group row">
                          <label className="col-lg-3 col-form-label form-control-label">Stadium Name</label>
                          <div className="col-lg-9">
                            <input className="form-control" disabled={true} value={this.state.stadium_name_en} name="stadiumname" onChange={this.myChangeHandler} type="text" placeholder=" Stadium Name" />
                          </div>
                        </div>
                        <div className="form-group row">
                          <label className="col-lg-3 col-form-label form-control-label">Start Date</label>
                          <div className="col-lg-9">
                            <input className="form-control" disabled={true} value={this.state.start_date} name="stadiumname" onChange={this.myChangeHandler} type="text" placeholder=" Start Date" />
                          </div>
                        </div>
                        <div className="form-group row">
                          <label className="col-lg-3 col-form-label form-control-label">End Date</label>
                          <div className="col-lg-9">
                            <input className="form-control" disabled={true} value={this.state.end_date} name="stadiumname" onChange={this.myChangeHandler} type="text" placeholder=" End Date" />
                          </div>
                        </div>
                      </div>
                      <div className="col-md-1" />
                    </div>
                  </div>
                  <div className="col-md-6 border-left" >
                    <div className="form-group row">
                      <div className="col-md-1" />
                      <div className="col-md-10" style={{ minHeight: '250px' }}>
                        {this.state.facilities.length == 0 &&
                          <div className="alert-message alert-message-warning">
                            <h4>
                              No Facilities selected</h4>
                            <p>
                              Please select Location and Stadium to search available facilities</p>
                          </div>
                        }
                        <ul className="text-center">{commentNodes}</ul>
                      </div>
                      <div className="col-md-1" />
                    </div>
                  </div>
                </div>

                <div className="form-group row">
                  <div className="col-md-9">
                    <h4 className="text-right text-muted">Total Amount : </h4>
                  </div>
                  <div className="col-md-3 text-center">
                    <span style={{ color: "orange", fontSize: '20px' }}>OMR {this.state.cost}</span>
                  </div>
                </div>

                <hr />
                <div className="form-group row">
                  <div className="col-lg-2">
                  </div>
                  <div className="col-lg-2"></div>
                  <div className="col-lg-1"></div>
                  <div className="col-lg-2">                    <button className="btn btn-info" disabled={this.state.approve_status === "Pending"} style={{ width: '100%', margin: '10px', color: 'white' }} onClick={this.confirmdelete}>Make Payment</button>
                  </div>
                  <div className="col-lg-2" style={{ margin: '0px' }}>
                    <button className="btn btn-warning" style={{ width: '100%', margin: '10px', color: 'white' }} onClick={this.confirmdelete}>Delete Event</button>

                  </div>
                  <div className="col-lg-2" >
                    <button className="btn btn-primary" style={{ width: '100%', margin: '10px' }} onClick={this.addfacilityEvent}>Update</button>
                  </div>
                  <div className="col-lg-1"></div>

                </div>



              </div>
            </div>

          </div> */}
          <br />
          <Footer />
        </div>
      </LoadingOverlay>
    )
  }
}
export default withRouter(EventDetails);
